<template>
  <div v-if="checkPermission(['permission:addUser'])">
    <el-tabs v-model="activeName">
      <el-tab-pane label="男性" name="first">
        <manUser @close="close" />
      </el-tab-pane>
      <el-tab-pane label="女性" name="second">
        <womenUser @close="close" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>

import manUser from './manUser' // 引入男性页组件
import womenUser from './womenUser' // 引入女性页组件
import checkPermission from '@/utils/permission' // 全局权限控制
export default {
  components: { manUser, womenUser },
  data() {
    return {
      activeName: 'first'
    }
  },
  methods: {
    checkPermission,
    close() {
      this.$emit('handelClose')
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
